<template>
    <div class="gst-base-chip d-inline-block">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'BaseChip',
};
</script>

<style lang="scss">
@import '@scssVariables';

.gst-base-chip {
    height: 28px;
    padding: theme-spacing(1, 2);
    line-height: line-height('3xl');
    border-radius: 28px;
    font-size: font-size('s');
}
</style>
